<template>
  <div
    class="list-item"
  >
    <div
      v-if="$slots.media"
      class="list-item-media"
    >
      <slot name="media" />
    </div>
    <div class="list-item-body m-font-size-100">
      <slot />
    </div>
    <BaseIcon
      class="list-item-icon"
      :size="16"
      icon="arrowRight"
    />
  </div>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  media: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style scoped>
.list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  border-bottom: var(--simple-border);
  transition: background-color .3s;
  &:hover {
    background-color: var(--gray-100);
  }
}

.list-item-body {
  display: flex;
  flex-direction: column;
  line-height: var(--line-height-headings);
}

.list-item-icon {
  margin-left: auto;
}

</style>
